import Vue from 'vue'
import VueResource from 'vue-resource'
import vuexI18n from 'vuex-i18n'
import VeeValidate from 'vee-validate';
import VueMoment from 'vue-moment'
import { sync } from 'vuex-router-sync'
import store from '@/store/store'
import router from '@/common/router'
import filters from '@/common/filters'
import translates from '@/common/translates'
import App from '@/modules/app/App.vue'
import AuthService from '@/services/AuthService'
import LocalizationService from '@/services/LocalizationService'
import VueDragDrop from 'vue-drag-drop'

Vue.use(VueResource)
Vue.use(VueDragDrop);
Vue.use(VueMoment)
Vue.use(vuexI18n.plugin, store)
Vue.use(filters)
Vue.use(VeeValidate, {
    dictionary: {
        ru: {
            messages: translates.ru.validation.messages,
            attributes: translates.ru.validation.attributes
        },
    }
})

Vue.i18n.add('ru', translates.ru)
Vue.i18n.add('en', translates.en)

sync(store, router)
Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
    provide: {
        auth: new AuthService(store, router),
        localization: new LocalizationService(),
    },
})





// WEBPACK FOOTER //
// ./src/main.js